<template>
  <div id="body">
    <div class="top">
      <router-link to="/login">
        <div>uuuuuuuuuuuuuuu</div>
      </router-link>

      <img src="http://bz.njrentong.com/2.png" class="topImage" />

      <div class="topTxt1">气温：{{ getTodayWeatherTempInfo }}℃</div>
      <!-- <div class="topbtn66"> -->
      <img src="@/assets/f11.png" class="f11" @click="screenfull" />
      <!-- </div> -->
      <div class="topTxt2">{{ y2 }}</div>
    </div>

    <div class="content">
      <div class="left">
        <div class="left1">
          <div class="left1bgn"></div>
          <div class="left1_icon1"></div>
          <div class="left1_icon2"></div>

          <div class="left1_txt">
            <img src="http://bz.njrentong.com/icon.png" class="left1_img1" />
            <div>停车场概况</div>
          </div>
          <div class="left1_con2">
            <div class="left_contxt1">总车位数</div>
            <animate-number
              from="0"
              :to="getAllNumByParkIdInfo.totalSpotNum"
              :key="getAllNumByParkIdInfo.totalSpotNum"
              duration="2000"
              class="left_contxt2"
              easing="easeOutQuad"
            ></animate-number>
            <!-- <div class="left_contxt2">502</div> -->
          </div>
          <div class="left1_con3">
            <div class="left1_con3txt1">
              <div class="left1_con3txt2">
                <img
                  src="http://bz.njrentong.com/p.png"
                  class="left1_con3img1"
                />
                <div class="left1_con3txt3">
                  <div class="left1_con3txt4">已售车位</div>
                  <animate-number
                    from="0"
                    :to="getAllNumByParkIdInfo.soldNum"
                    :key="getAllNumByParkIdInfo.soldNum"
                    duration="2000"
                    class="left1_con3txt5"
                    easing="easeOutQuad"
                  ></animate-number>
                  <!-- <div class="left1_con3txt5">123</div> -->
                </div>
              </div>
              <div class="left1_con3txt2">
                <img
                  src="http://bz.njrentong.com/weishouchewei.png"
                  class="left1_con3img1"
                />
                <div class="left1_con3txt3">
                  <div class="left1_con3txt4">未售车位</div>
                  <animate-number
                    from="0"
                    :to="getAllNumByParkIdInfo.noSoldNum"
                    :key="getAllNumByParkIdInfo.noSoldNum"
                    duration="2000"
                    class="left1_con3txt5"
                    easing="easeOutQuad"
                  ></animate-number>
                  <!-- <div class="left1_con3txt5">123</div> -->
                </div>
              </div>
              <div></div>
            </div>
            <div class="left1_con3txt6">
              <div class="left1_con3txt2">
                <img
                  src="http://bz.njrentong.com/linting'.png"
                  class="left1_con3img1"
                />
                <div class="left1_con3txt3">
                  <div class="left1_con3txt4">临停车位</div>
                  <animate-number
                    from="0"
                    :to="getAllNumByParkIdInfo.shortSpotNum"
                    :key="getAllNumByParkIdInfo.shortSpotNum"
                    duration="2000"
                    class="left1_con3txt5"
                    easing="easeOutQuad"
                  ></animate-number>
                  <!-- <div class="left1_con3txt5">158</div> -->
                </div>
              </div>
              <div class="left1_con3txt2">
                <img
                  src="http://bz.njrentong.com/vip.png"
                  class="left1_con3img1"
                />
                <div class="left1_con3txt3">
                  <div class="left1_con3txt4">VIP位数</div>
                  <animate-number
                    from="0"
                    :to="getAllNumByParkIdInfo.vipSpotNum"
                    :key="getAllNumByParkIdInfo.vipSpotNum"
                    duration="2000"
                    class="left1_con3txt5"
                    easing="easeOutQuad"
                  ></animate-number>
                  <!-- <div class="left1_con3txt5">50</div> -->
                </div>
              </div>
              <div></div>
            </div>
          </div>
        </div>
        <div class="left2">
          <div class="left1bgn"></div>
          <div class="left1_icon1"></div>
          <div class="left1_icon2"></div>
          <div class="left1_txt">
            <img src="http://bz.njrentong.com/icon.png" class="left1_img1" />
            <div>停车场车辆概况</div>
          </div>
          <div class="left1_con3">
            <div class="left1_con3txt1">
              <div class="left1_con3txt2">
                <div class="left_con4">
                  <div class="left2_con3border"></div>
                  <div class="left2_con3overmask"></div>
                  <img
                    src="http://bz.njrentong.com/vipc.png"
                    class="left1_con3img2"
                  />
                </div>

                <div class="left1_con3txt7">
                  <div class="left1_con3txt8">VIP车辆数</div>
                  <animate-number
                    from="0"
                    :to="getAllCarNumByParkIdInfo.vipCarNum"
                    :key="getAllCarNumByParkIdInfo.vipCarNum"
                    duration="2000"
                    class="left1_con3txt9"
                    easing="easeOutQuad"
                  ></animate-number>
                  <!-- <div class="left1_con3txt9">156</div> -->
                </div>
              </div>
              <div class="left1_con3txt2">
                <div class="left_con4">
                  <div class="left2_con3border"></div>
                  <div class="left2_con3overmask"></div>
                  <img
                    src="http://bz.njrentong.com/baoyue.png"
                    class="left1_con3img3"
                  />
                </div>
                <div class="left1_con3txt7">
                  <div class="left1_con3txt8">包月车辆数</div>
                  <animate-number
                    from="0"
                    :to="getAllCarNumByParkIdInfo.custCarNum"
                    :key="getAllCarNumByParkIdInfo.custCarNum"
                    duration="2000"
                    class="left1_con3txt9"
                    easing="easeOutQuad"
                  ></animate-number>
                  <!-- <div class="left1_con3txt9">156</div> -->
                </div>
              </div>
            </div>
            <div class="left1_con3txt10">
              <div class="left1_con3txt2">
                <div class="left_con4">
                  <div class="left2_con3border"></div>
                  <div class="left2_con3overmask"></div>
                  <img
                    src="http://bz.njrentong.com/heimingd.png"
                    class="left1_con3img4"
                  />
                </div>

                <div class="left1_con3txt7">
                  <div class="left1_con3txt8">黑名单车辆数</div>
                  <animate-number
                    from="0"
                    :to="getAllCarNumByParkIdInfo.blacklistCarNum"
                    :key="getAllCarNumByParkIdInfo.blacklistCarNum"
                    duration="2000"
                    class="left1_con3txt9"
                    easing="easeOutQuad"
                  ></animate-number>
                  <!-- <div class="left1_con3txt9">32</div> -->
                </div>
              </div>
              <div class="left1_con3txt2">
                <div class="left_con4">
                  <div
                    class="left2_con3border"
                    style="background: #9602eb"
                  ></div>
                  <div
                    class="left2_con3overmask"
                    style="
                      background: linear-gradient(
                        87deg,
                        #ae07d8 0%,
                        rgba(174, 7, 216, 0.2) 100%
                      );
                    "
                  ></div>
                  <img
                    src="http://bz.njrentong.com/teshu.png"
                    class="left1_con3img5"
                  />
                </div>
                <div class="left1_con3txt7">
                  <div class="left1_con3txt8">特殊车辆数</div>
                  <animate-number
                    from="0"
                    :to="getAllCarNumByParkIdInfo.otherCarNum"
                    :key="getAllCarNumByParkIdInfo.otherCarNum"
                    duration="2000"
                    class="left1_con3txt9"
                    easing="easeOutQuad"
                  ></animate-number>
                  <!-- <div class="left1_con3txt9">0</div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="left3">
          <div class="left1bgn"></div>
          <div class="left1_icon1"></div>
          <div class="left1_icon2"></div>
          <div class="left1_txt">
            <img src="http://bz.njrentong.com/icon.png" class="left1_img1" />
            <div>呼叫次数</div>
          </div>
          <div id="charts1" class="charts"></div>

          <div class="left3_txt2">
            <div class="left3_txt3"></div>
            入口呼叫次数
            <animate-number
              from="1"
              to="5672"
              duration="2000"
              class="left3_txt4"
              easing="easeOutQuad"
            ></animate-number>
            <!-- <div class="left3_txt4">5672</div> -->
          </div>

          <div class="left3_txt5">
            <div class="left3_txt6"></div>
            出口呼叫次数
            <animate-number
              from="1"
              to="612"
              duration="2000"
              class="left3_txt7"
              easing="easeOutQuad"
            ></animate-number>
            <!-- <div class="left3_txt7">5672</div> -->
          </div>
        </div>
      </div>
      <div class="center">
        <div class="center_title">{{ parkName }}实时停车数据</div>
        <div class="center_title1">
          <dv-border-box-7
            class="center_title2"
            :color="['#1F3A89', '#31CDFC']"
            backgroundColor="transparent"
          >
            <animate-number
              from="0"
              :to="getTotalShortSpotNumByParkIdInfo"
              :key="getTotalShortSpotNumByParkIdInfo"
              duration="2000"
              class="center_title3"
              easing="easeOutQuad"
            ></animate-number>
            <!-- <div class="center_title3">158</div> -->

            <div>临停车位总数</div>
          </dv-border-box-7>
          <dv-border-box-7
            class="center_title2"
            :color="['#1F3A89', '#31CDFC']"
            backgroundColor="transparent"
          >
            <!-- <div class="center_title3">71</div> -->
            <animate-number
              from="1"
              :to="getNowTotalShortNumByParkIdInfo"
              :key="getNowTotalShortNumByParkIdInfo"
              duration="2000"
              class="center_title3"
              easing="easeOutQuad"
            ></animate-number>
            <div>在停车辆数</div>
          </dv-border-box-7>
          <dv-border-box-7
            class="center_title2"
            :color="['#1F3A89', '#31CDFC']"
            backgroundColor="transparent"
          >
            <!-- <div class="center_title3">87</div> -->
            <animate-number
              from="1"
              :to="
                getTotalShortSpotNumByParkIdInfo -
                getNowTotalShortNumByParkIdInfo
              "
              :key="
                getTotalShortSpotNumByParkIdInfo -
                getNowTotalShortNumByParkIdInfo
              "
              duration="2000"
              class="center_title3"
              easing="easeOutQuad"
            ></animate-number>
            <div>剩余车位数</div>
          </dv-border-box-7>
          <dv-border-box-7
            class="center_title2"
            :color="['#1F3A89', '#31CDFC']"
            backgroundColor="transparent"
          >
            <!-- <div class="center_title3">5316</div> -->
            <animate-number
              from="1"
              :to="getNowMonthTotalShortNumByParkIdInfo"
              :key="getNowMonthTotalShortNumByParkIdInfo"
              duration="2000"
              class="center_title3"
              easing="easeOutQuad"
            ></animate-number>
            <div>本月临停车数量</div>
          </dv-border-box-7>
        </div>
        <div class="center_col3">
          <dv-border-box-7
            class="center_col3txt1"
            :color="['#1F3A89', '#31CDFC']"
            backgroundColor="transparent"
            style="padding: 2px"
          >
            <!-- src="https://yypark.njrentong.com/back/files/parkPic/2021-12-20/2/c/20211220075224891_out_img_full.jpg" -->
            <!-- :src="
                'http://yypark.njrentong.com/back/files/' +
                getLastFiveCarByParkIdInfo[alertIndex].enterPicdir
              " -->
            <el-image
              :src="
                'http://yypark.njrentong.com/back/files/' +
                getLastOneEnterCarByParkIdInfo.enterPicdir
              "
              style="width: 100%; height: 100%"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </dv-border-box-7>

          <!-- <dv-scroll-board
            :config="config"
            class="center_col3table"
            @click="openDia"
          /> -->

          <div class="center_col4txt1">
            <div class="center_col4txt2" style="margin-top: 0">
              <div class="center_col4txt3">车牌号码</div>
              <div class="center_col4txt4">
                {{ getLastOneEnterCarByParkIdInfo.enterCaridCn }}
              </div>
            </div>
            <div class="center_col4txt2">
              <div class="center_col4txt3">入场时间</div>
              <div class="center_col4txt4">
                {{ getLastOneEnterCarByParkIdInfo.enterTime }}
              </div>
            </div>
            <div class="center_col4txt2">
              <div class="center_col4txt3">车辆类型</div>
              <div class="center_col4txt4">
                {{ getLastOneEnterCarByParkIdInfo.enterTypeTxt }}
              </div>
            </div>
            <div class="center_col4txt2">
              <div class="center_col4txt3">入场状态</div>
              <div class="center_col4txt4">
                {{ getLastOneEnterCarByParkIdInfo.isInTxt }}
              </div>
            </div>
            <div class="center_col4txt2">
              <div class="center_col4txt3">入场信息</div>
              <div class="center_col4txt4">
                {{ getLastOneEnterCarByParkIdInfo.enterMessage }}
              </div>
            </div>
            <div class="center_col4txt2">
              <div class="center_col4txt3">上次入场</div>
              <div class="center_col4txt4">
                {{ getLastOneEnterCarByParkIdInfo.lastEnterTime }}
              </div>
            </div>
          </div>
        </div>
        <div class="center_col4border">
          <div class="center_col4border1"></div>
          <img src="http://bz.njrentong.com/gelixian.png" class="gelixian" />
        </div>
        <div class="center_col4">
          <dv-border-box-7
            class="center_col3txt1"
            style="padding: 2px"
            :color="['#1F3A89', '#31CDFC']"
            backgroundColor="transparent"
          >
            <el-image
              :src="
                'https://yypark.njrentong.com/back/files/' +
                getLastOneOutCarByParkIdInfo.outPicdir
              "
              style="width: 100%; height: 100%"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </dv-border-box-7>

          <div class="center_col4txt1">
            <div class="center_col4txt2">
              <div class="center_col4txt3">车牌号码</div>
              <div class="center_col4txt4">
                {{ getLastOneOutCarByParkIdInfo.outCaridCn }}({{
                  getLastOneOutCarByParkIdInfo.outTypeTxt
                }})
              </div>
            </div>
            <div class="center_col4txt2">
              <div class="center_col4txt3">停放时长</div>
              <div class="center_col4txt4">
                {{ getLastOneOutCarByParkIdInfo.totalTimeStr }}
              </div>
            </div>
            <div class="center_col4txt2">
              <div class="center_col4txt3">入场时间</div>
              <div class="center_col4txt4">
                {{ getLastOneOutCarByParkIdInfo.enterTime }}
              </div>
            </div>
            <div class="center_col4txt2">
              <div class="center_col4txt3">离场时间</div>
              <div class="center_col4txt4">
                {{ getLastOneOutCarByParkIdInfo.outTime }}
              </div>
            </div>
            <div class="center_col4txt2">
              <div class="center_col4txt3">应付金额</div>
              <div class="center_col4txt4">
                {{ getLastOneOutCarByParkIdInfo.money / 100 }}元
              </div>
            </div>
          </div>
        </div>
        <div class="center_col5">
          <div class="left1bgn"></div>
          <div class="left1_icon1"></div>
          <div class="left1_icon2"></div>
          <div class="center_col5txt">当日进出场次数</div>
          <!-- <div class="center_col5txt">进度</div> -->
          <div class="progress">
            <ProgressBar
              :percentage="progressnum"
              :percentage1="progressnum1"
            ></ProgressBar>
          </div>
          <div class="center_col5txt1">
            <div class="center_col5txt2">
              入场车次：
              <animate-number
                from="0"
                :to="inAndOutAndInSpotTimeInfo.inTimes"
                :key="inAndOutAndInSpotTimeInfo.inTimes"
                duration="2000"
                class="center_col5txt3"
                easing="easeOutQuad"
              ></animate-number>
              <!-- <div class="center_col5txt3">769</div> -->
            </div>
            <div class="center_col5txt2">
              出场车次：
              <animate-number
                from="0"
                :to="inAndOutAndInSpotTimeInfo.outTimes"
                :key="inAndOutAndInSpotTimeInfo.outTimes"
                duration="2000"
                class="center_col5txt3"
                easing="easeOutQuad"
              ></animate-number>
              <!-- <div class="center_col5txt3">627</div> -->
            </div>
          </div>
          <div class="center_col5txt4">当前车辆停放时长</div>
          <div id="charts4" class="charts2"></div>
        </div>
      </div>
      <div class="right">
        <div class="right_col1">
          <div class="left1bgn"></div>
          <div class="left1_icon1"></div>
          <div class="left1_icon2"></div>
          <div class="right_col1txt">
            <div class="right_col1txt2">
              <animate-number
                from="1"
                :to="showParkInComeInfo.allDayInCome / 100"
                :key="showParkInComeInfo.allDayInCome"
                duration="2000"
                easing="easeOutQuad"
              ></animate-number>
              <div class="right_col1txt3">当日总收入</div>
            </div>
            <div class="right_col1txt2">
              <!-- 215384 -->
              <animate-number
                from="1"
                :to="showParkInComeInfo.allMonthInCome / 100"
                :key="showParkInComeInfo.allMonthInCome"
                duration="2000"
                easing="easeOutQuad"
              ></animate-number>
              <div class="right_col1txt3">当月总收入</div>
            </div>
          </div>
          <div class="right_col1txt4">当日实时收入统计</div>
          <div id="charts2" class="charts2"></div>
        </div>
        <div class="right_col2">
          <div class="left1bgn"></div>
          <div class="left1_icon1"></div>
          <div class="left1_icon2"></div>
          <div class="left1_txt">
            <img src="http://bz.njrentong.com/icon.png" class="left1_img1" />
            <div>机器人数据汇总</div>
          </div>
          <div class="left1_con3">
            <div class="left1_con3txt1">
              <div class="left1_con3txt2">
                <div class="left_con4">
                  <div class="left2_con3border"></div>
                  <div class="left2_con3overmask"></div>
                  <img
                    src="http://bz.njrentong.com/weiting.png"
                    class="weiting"
                  />
                </div>

                <div class="left1_con3txt7">
                  <div class="left1_con3txt8">违规停车数量</div>
                  <!-- <div class="left1_con3txt9">221</div> -->
                  <animate-number
                    from="1"
                    :to="weiguinum"
                    :key="weiguinum"
                    duration="2000"
                    class="left1_con3txt9"
                    easing="easeOutQuad"
                  ></animate-number>
                </div>
              </div>
              <div class="left1_con3txt2">
                <div class="left_con4">
                  <div
                    class="left2_con3border"
                    style="background: #9602eb"
                  ></div>
                  <div
                    class="left2_con3overmask"
                    style="
                      background: linear-gradient(
                        87deg,
                        #ae07d8 0%,
                        rgba(174, 7, 216, 0.2) 100%
                      );
                    "
                  ></div>
                  <img
                    src="http://bz.njrentong.com/yichang.png"
                    class="yichang"
                  />
                </div>
                <div class="left1_con3txt7">
                  <div class="left1_con3txt8">异常告警数量</div>
                  <animate-number
                    from="1"
                    :to="yichangnum"
                    :key="yichangnum"
                    duration="2000"
                    class="left1_con3txt9"
                    easing="easeOutQuad"
                  ></animate-number>
                  <!-- <div class="left1_con3txt9">76</div> -->
                </div>
              </div>
            </div>
            <div class="left1_con3txt10">
              <div class="left1_con3txt2">
                <div class="left_con4">
                  <div class="left2_con3border"></div>
                  <div class="left2_con3overmask"></div>
                  <img src="http://bz.njrentong.com/yxun.png" class="yxun" />
                </div>

                <div class="left1_con3txt7">
                  <div class="left1_con3txt8">已巡车位数</div>
                  <!-- <div class="left1_con3txt9">465</div> -->
                  <animate-number
                    from="1"
                    :to="spotNum"
                    :key="spotNum"
                    duration="2000"
                    class="left1_con3txt9"
                    easing="easeOutQuad"
                  ></animate-number>
                </div>
              </div>
              <div class="left1_con3txt2">
                <div class="left_con4">
                  <div class="left2_con3border"></div>
                  <div class="left2_con3overmask"></div>
                  <img src="http://bz.njrentong.com/renwu.png" class="renwu" />
                </div>
                <div class="left1_con3txt7">
                  <div class="left1_con3txt8">任务完成数</div>
                  <!-- <div class="left1_con3txt9">156</div>   taskNum:0,weiguinum:0,
      yichangnum:0,
      spotNum:0,
      -->
                  <animate-number
                    from="1"
                    :to="taskNum"
                    :key="taskNum"
                    duration="2000"
                    class="left1_con3txt9"
                    easing="easeOutQuad"
                  ></animate-number>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right_col3">
          <div class="left1bgn"></div>
          <div class="left1_icon1"></div>
          <div class="left1_icon2"></div>
          <div class="left1_txt">
            <img src="http://bz.njrentong.com/icon.png" class="left1_img1" />
            <div>泊位周转率</div>
          </div>
          <div class="left1_con2">
            <div class="left_contxt1">泊位周转率</div>
            <div class="right_contxt2">泊位周转率=总停车笔数/泊位数</div>
          </div>
          <div id="charts3" class="charts2"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var angle = 0;
var value = "90";
var seriesData = [
  { name: "入口呼叫次数", value: 60 },
  { name: "出口呼叫次数", value: 40 },
];
var that;
var echarts1;
var echarts2;
var echarts3;
var echarts4;
var interval1;
var interval2;
var interval3;
var interval4;

import screenfull from "screenfull";

import ProgressBar from "./progressBar.vue";
import { get, post } from "@/util/axios";
export default {
  name: "view1",
  components: { ProgressBar },
  data() {
    let that = this;

    return {
      parkId: "2",
      showParkInComeInfo: {
        allDayInCome: 0,
        allMonthInCome: 0,
        bizShowParkDtos: [],
      },
      taskNum: 0,
      weiguinum: 0,
      yichangnum: 0,
      spotNum: 0,
      getTotalShortSpotNumByParkIdInfo: 0,
      getLastOneOutCarByParkIdInfo: {},
      alertIndex: 0,
      getTodayWeatherTempInfo: "",
      getAllCarNumByParkIdInfo: {
        blacklistCarNum: 0,
        custCarNum: 0,
        otherCarNum: 0,
        vipCarNum: 0,
      },
      getNowTotalShortNumByParkIdInfo: 0,
      getNowMonthTotalShortNumByParkIdInfo: 0,
      getLastFiveCarByParkIdInfo: [{ enterPicdir: "" }],
      getAllNumByParkIdInfo: {
        noSoldNum: 0,
        shortSpotNum: 0,
        soldNum: 0,
        totalSpotNum: 0,
        vipSpotNum: 0,
      },
      y1: "",
      y2: "",
      progressnum: 0.5,
      progressnum1: 0.5,
      config: {
        header: ["入场时间", "车牌号", "类型", "状态"],
        data: [],
        columnWidth: [120, 90, 70, 90],
        headerBGC: "transparent",
        oddRowBGC: "transparent",
        evenRowBGC: "transparent",
      },
      option1: {
        backgroundColor: "transparent",
        title: {
          text: "{a|" + "呼叫次数" + "}",
          x: "center",
          y: "center",
          textStyle: {
            rich: {
              a: {
                fontSize: 20,
                color: "#29EEF3",
              },

              c: {
                fontSize: 20,
                color: "#ffffff",
                // padding: [5,0]
              },
            },
          },
        },
        // legend: {
        //   orient: "vertical",
        //   top: "center",
        //   left: 0,
        //   textStyle: {
        //     align: "left",
        //     verticalAlign: "middle",
        //     rich: {
        //       name: {
        //         color: "#00FFF6",
        //         fontSize: 10,
        //       },
        //       name1: {
        //         color: "#FFF715",
        //         fontSize: 10,
        //       },
        //       rate: {
        //         color: "#90A9C8",
        //         fontSize: 10,
        //       },
        //     },
        //   },
        //   data: ["入口呼叫次数", "出口呼叫次数"],
        //   formatter: (name) => {
        //     if (seriesData.length) {
        //       const item = seriesData.filter((item) => item.name === name)[0];
        //       if (name == "入口呼叫次数") {
        //         return `{rate|${name}\n} {name| ${item.value}}`;
        //       } else {
        //         return `{rate|${name}\n} {name1| ${item.value}}`;
        //       }
        //     }
        //   },
        // },
        series: [
          {
            name: "ring5",
            type: "custom",
            coordinateSystem: "none",
            renderItem: function (params, api) {
              return {
                type: "arc",
                shape: {
                  cx: api.getWidth() / 2,
                  cy: api.getHeight() / 2,
                  r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.6,
                  startAngle: ((0 + angle) * Math.PI) / 180,
                  endAngle: ((90 + angle) * Math.PI) / 180,
                },
                style: {
                  stroke: "#0CD3DB",
                  fill: "transparent",
                  lineWidth: 1.5,
                },
                silent: true,
              };
            },
            data: [0],
          },
          {
            name: "ring5",
            type: "custom",
            coordinateSystem: "none",
            renderItem: function (params, api) {
              return {
                type: "arc",
                shape: {
                  cx: api.getWidth() / 2,
                  cy: api.getHeight() / 2,
                  r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.6,
                  startAngle: ((180 + angle) * Math.PI) / 180,
                  endAngle: ((270 + angle) * Math.PI) / 180,
                },
                style: {
                  stroke: "#0CD3DB",
                  fill: "transparent",
                  lineWidth: 1.5,
                },
                silent: true,
              };
            },
            data: [0],
          },
          {
            name: "ring5",
            type: "custom",
            coordinateSystem: "none",
            renderItem: function (params, api) {
              return {
                type: "arc",
                shape: {
                  cx: api.getWidth() / 2,
                  cy: api.getHeight() / 2,
                  r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.65,
                  startAngle: ((270 + -angle) * Math.PI) / 180,
                  endAngle: ((40 + -angle) * Math.PI) / 180,
                },
                style: {
                  stroke: "#0CD3DB",
                  fill: "transparent",
                  lineWidth: 1.5,
                },
                silent: true,
              };
            },
            data: [0],
          },
          {
            name: "ring5",
            type: "custom",
            coordinateSystem: "none",
            renderItem: function (params, api) {
              return {
                type: "arc",
                shape: {
                  cx: api.getWidth() / 2,
                  cy: api.getHeight() / 2,
                  r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.65,
                  startAngle: ((90 + -angle) * Math.PI) / 180,
                  endAngle: ((220 + -angle) * Math.PI) / 180,
                },
                style: {
                  stroke: "#0CD3DB",
                  fill: "transparent",
                  lineWidth: 1.5,
                },
                silent: true,
              };
            },
            data: [0],
          },
          {
            name: "ring5",
            type: "custom",
            coordinateSystem: "none",
            renderItem: function (params, api) {
              let x0 = api.getWidth() / 2;
              let y0 = api.getHeight() / 2;
              let r = (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.65;
              let point = that.getCirlPoint(x0, y0, r, 90 + -angle);
              return {
                type: "circle",
                shape: {
                  cx: point.x,
                  cy: point.y,
                  r: 4,
                },
                style: {
                  stroke: "#0CD3DB", //粉
                  fill: "#0CD3DB",
                },
                silent: true,
              };
            },
            data: [0],
          },
          {
            name: "ring5", //绿点
            type: "custom",
            coordinateSystem: "none",
            renderItem: function (params, api) {
              let x0 = api.getWidth() / 2;
              let y0 = api.getHeight() / 2;
              let r = (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.65;
              let point = that.getCirlPoint(x0, y0, r, 270 + -angle);
              return {
                type: "circle",
                shape: {
                  cx: point.x,
                  cy: point.y,
                  r: 4,
                },
                style: {
                  stroke: "#0CD3DB", //绿
                  fill: "#0CD3DB",
                },
                silent: true,
              };
            },
            data: [0],
          },
          {
            name: "",
            type: "pie",
            radius: ["55%", "45%"],
            silent: true,
            clockwise: true,
            startAngle: 90,
            z: 0,
            zlevel: 0,
            label: {
              normal: {
                position: "center",
              },
            },
            data: [
              {
                value: value,
                name: " ",
                itemStyle: {
                  normal: {
                    color: {
                      // 完成的圆环的颜色
                      colorStops: [
                        {
                          offset: 0,
                          color: "#00FFF6", // 0% 处的颜色
                        },
                        {
                          offset: 1,
                          color: "#00FFF6", // 100% 处的颜色
                        },
                      ],
                    },
                  },
                },
              },
              {
                value: 100 - value,
                name: " ",
                label: {
                  normal: {
                    show: false,
                  },
                },
                itemStyle: {
                  normal: {
                    color: "#FFF715",
                  },
                },
              },
            ],
          },

          {
            name: "",
            type: "gauge",
            radius: "65%",
            center: ["50%", "50%"],
            startAngle: 0,
            endAngle: 359.9,
            splitNumber: 8,
            hoverAnimation: true,
            axisTick: {
              show: false,
            },
            splitLine: {
              length: 20,
              lineStyle: {
                width: 2.5,
                color: "#061740",
              },
            },
            axisLabel: {
              show: false,
            },
            pointer: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                opacity: 0,
              },
            },
            detail: {
              show: false,
            },
            data: [
              {
                value: 0,
                name: "",
              },
            ],
          },
        ],
      },
      option2: {
        grid: {
          x: 30,
          y: 30,
          x2: 40,
          y2: 40,
          borderWidth: 10,
        },
        xAxis: {
          type: "category",
          data: [],
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#90A9C8",
              width: 0,
              type: "solid",
            },
          },
        },
        yAxis: {
          type: "value",
          lineStyle: {
            color: "#90A9C8",
            width: 0,
            type: "solid",
          },
          splitLine: {
            lineStyle: {
              color: "#283184",
            },
          },
        },
        series: [
          {
            data: [],
            type: "line",
            areaStyle: {
              color: "#292F7D",
            },
            itemStyle: {
              color: "#04F4F1",
            },
          },
        ],
      },
      option3: {
        grid: {
          x: 30,
          y: 30,
          x2: 40,
          y2: 40,
          borderWidth: 10,
        },
        xAxis: {
          type: "category",
          data: [],
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            fontSize: 16,
            lineStyle: {
              color: "#90A9C8",
              width: 0,
              type: "solid",
            },
            showMaxLabel: true,
            interval: 0,
            rotate: 30,
          },
        },
        yAxis: {
          type: "value",
          lineStyle: {
            color: "#90A9C8",
            width: 10,
            type: "solid",
          },
          splitLine: {
            lineStyle: {
              color: "#253481",
            },
          },
        },
        series: [
          {
            data: [0],
            type: "bar",
            itemStyle: {
              color: "#04F4F1",
            },
            barWidth: 12, //柱图宽度
          },
        ],
      },
      option4: {
        color: [
          "#00FFF6",
          "#FFF715",
          "#0EDC7B",
          "#910CEB",
          "#3CC6FF",
          "transparent",
        ],
        tooltip: {
          trigger: "item",
        },
        legend: {
          show: false,
        },
        series: [
          {
            center: ["55%", "60%"],
            type: "pie",
            roseType: "radius",
            radius: ["40%", "80%"],
            startAngle: 130,
            data: [
              {
                value: 0,
                name: "30分钟以内",
              },
              {
                value: 0,
                name: "30—60分钟",
              },
              {
                value: 0,
                name: "2—4小时",
              },
              {
                value: 0,
                name: "4小时以上",
              },

              {
                value: 0,
                name: "1—2小时",
              },
              {
                value: 0,
                name: "",
                labelLine: {
                  lineStyle: {
                    color: "transparent",
                  },
                  length: 0,
                },
                label: {
                  normal: {
                    color: "transparent",
                  },
                  emphasis: {
                    show: false,
                  },
                },
                itemStyle: {
                  normal: {
                    color: "transparent",
                  },
                },
              },
            ],
            label: {
              normal: {
                formatter: function (params, ticket, callback) {
                  if (params.name === "") {
                    return null;
                  } else {
                    return "{font|" + params.name + "}";
                  }
                },
                // formatter: "{font|{params.name }}",
                rich: {
                  font: {
                    fontSize: 15,
                    padding: [5, 0],
                    color: "#90A9C8",
                  },
                  hr: {
                    height: 0,
                    borderWidth: 1,
                    width: "100%",
                    borderColor: "#90A9C8",
                  },
                },
              },
            },
            labelLine: {
              lineStyle: {
                color: "#90A9C8",
              },
              length: 1,
              length2: 50,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0,0,0,0.5)",
              },
            },
          },
        ],
      },
      inAndOutAndInSpotTimeInfo: {
        in30M: "0",
        inCome: null,
        inPencentage: "50%",
        inTimes: "0",
        out1In2H: "0",
        out2In4H: "0",
        out30In60M: "0",
        out4H: "1",
        outPencentage: "50%",
        outTimes: "0",
        time: null,
      },
      getLastOneEnterCarByParkIdInfo: {
        addTime: "",
        addTimeEnd: null,
        addTimeEnd2: null,
        addTimeStart: null,
        addTimeStart2: null,
        chargeTime: null,
        cloudParkRecordId: "",
        correct_caridCn: null,
        enterCaridCn: "",
        enterMessage: "",
        enterPicdir: "",
        enterTime: "",
        enterType: 1,
        imageFragmentFileHttp: null,
        imgFileHttp: null,
        isAlreadyPay: 1,
        isIn: 2,
        lastEnterTime: null,
        localParkRecordId: "",
        money: null,
        needPay: 0,
        nowTime: null,
        nowType: 0,
        outCaridCn: null,
        outCorrectidCn: null,
        outPicdir: null,
        outTime: null,
        outType: null,
        parkId: "1",
        parkInSpotId: null,
        parkName: null,
        parkRecordId: "95889",
        parkRecordIdTemp: null,
        remark: null,
        tempPay: 0,
        totalTimeStr: null,
      },
      parkName: "",
    };
  },
  mounted() {
    that = this;
    if (this.$route.query.id) {
      this.parkId = this.$route.query.id;
    }
    echarts1 = that.$echarts.init(document.getElementById("charts1"));
    echarts2 = that.$echarts.init(document.getElementById("charts2"));
    echarts3 = that.$echarts.init(document.getElementById("charts3"));
    echarts4 = that.$echarts.init(document.getElementById("charts4"));
    that.getParkByParkId();
    that.drawLine();
    that.getTodayWeatherTemp();
    that.getAllCarNumByParkId();
    that.getAllNumByParkId();
    that.getNowTotalShortNumByParkId();
    that.getTotalShortSpotNumByParkId();
    that.getLastOneEnterCarByParkId();
    that.getNowMonthTotalShortNumByParkId();
    that.getLastFiveCarByParkId();
    that.getLastOneOutCarByParkId();
    that.getBerthTurnover();
    that.getSpotNum();
    that.getUnreasonableCarNum();
    that.getTasks();
    that.inAndOutAndInSpotTime();
    that.showParkInCome();

    // setTimeout(() => {
    //   this.progressnum=0.7
    //         this.progressnum1=0.3

    // }, 1000);
    interval2 = setInterval(function () {
      that.getTime();
    }, 1000);
    interval3 = setInterval(function () {
      // let a = 0;
      let a = Math.round(Math.random() * 10) / 10;

      that.getAllCarNumByParkId();
      that.getAllNumByParkId();
      that.getNowTotalShortNumByParkId();
      that.getTotalShortSpotNumByParkId();
      that.getLastOneEnterCarByParkId();

      that.getNowMonthTotalShortNumByParkId();
      that.getLastFiveCarByParkId();
      that.getLastOneOutCarByParkId();
      that.getBerthTurnover();
      that.getSpotNum();
      that.getUnreasonableCarNum();
      that.getTasks();
      that.inAndOutAndInSpotTime();
      that.showParkInCome();
    }, 3000);
    interval4 = setInterval(function () {
      that.getTodayWeatherTemp();
    }, 1000 * 60 * 60);
  },
  destroyed() {
    clearInterval(interval1);
    clearInterval(interval2);
    clearInterval(interval3);
    clearInterval(interval4);
  },
  methods: {
    screenfull() {
      screenfull.toggle();
    },

    getLastOneEnterCarByParkId() {
      post("/yypark/back/wx/sys/getLastOneEnterCarByParkId", {
        parkId: that.parkId,
      }).then((res) => {
        if (res.state) {
          let d = res.data;
          if (d.isIn == 1) {
            d.isInTxt = "已入场";
          } else {
            d.isInTxt = "未入场";
          }

          if (d.enterType == 1) {
            d.enterTypeTxt = "包月车";
          } else if (d.enterType == 2) {
            d.enterTypeTxt = "临停车";
          } else if (d.enterType == 3) {
            d.enterTypeTxt = "登记车";
          } else if (d.enterType == 4) {
            d.enterTypeTxt = "VIP ";
          } else if (d.enterType == 5) {
            d.enterTypeTxt = "无牌车";
          } else if (d.enterType == 8) {
            d.enterTypeTxt = "短租车";
          } else if (d.enterType == 9) {
            d.enterTypeTxt = "访客授权车";
          }
          that.getLastOneEnterCarByParkIdInfo = d;
        } else {
        }
      });
    },
    /**
     * row	所在行数据	Array<String>	---	---
        ceil	单元格数据	Array<Array>	---	[]
        rowIndex	行索引	Number	---	---
        columnIndex	列索引	Number	---	---
        #mouseover事件
 */
    openDia(row, ceil, rowIndex, columnIndex) {
      this.alertIndex = row.rowIndex;
    },
    getParkByParkId() {
      post("/yypark/back/wx/biz/getParkByParkId", {
        parkId: that.parkId,
      }).then((res) => {
        if (res.state) {
          that.parkName = res.data.parkName;
        } else {
        }
      });
    },
    //入场车辆列表
    getLastFiveCarByParkId() {
      post("/yypark/back/wx/sys/getLastFiveCarByParkId", {
        parkId: that.parkId,
      }).then((res) => {
        if (res.state) {
          that.getLastFiveCarByParkIdInfo = res.data;
          let list = [];
          let list1 = res.data;
          let a = [];
          let txt = "";
          list1.forEach((item, index) => {
            // a.push(index + "");
            txt = "";
            a.push(item.enterTime.substr(5));
            a.push(item.enterCaridCn);
            switch (item.enterType) {
              case 1:
                txt = "包月车";
                break;
              case 2:
                txt = "临停车";
                break;
              case 3:
                txt = "登记车";
                break;
              case 4:
                txt = "VIP";
                break;
              case 5:
                txt = "无牌车";
                break;

              case 8:
                txt = "短租";
                break;
              case 9:
                txt = "访客授权车";
                break;
              default:
                break;
            }
            a.push(txt);

            a.push(item.isIn == 1 ? "已入场1" : "禁止入场");

            list.push(a);
            a = [];
          });
          let da = JSON.parse(JSON.stringify(this.config));
          // ["1", " 巡逻任务 ", "10:30:00", "进行中"]
          that.config = da;
          da.data = list;
          // that.getLastFiveCarByParkIdInfo = res.data;
        } else {
        }
      });
    },

    getLastOneOutCarByParkId() {
      post("/yypark/back/wx/sys/getLastOneOutCarByParkId", {
        parkId: that.parkId,
      }).then((res) => {
        if (res.state) {
          let d = res.data;
          let txt = "";
          // a.push(index + "");
          txt = "";

          switch (d.outType) {
            case 1:
              txt = "包月车";
              break;
            case 2:
              txt = "临停车";
              break;
            case 3:
              txt = "登记车";
              break;
            case 4:
              txt = "VIP";
              break;
            case 5:
              txt = "无牌车";
              break;

            case 8:
              txt = "短租";
              break;
            case 9:
              txt = "访客授权车";
              break;
            default:
              break;
          }
          d.outTypeTxt = txt;
          that.getLastOneOutCarByParkIdInfo = d;
        } else {
        }
      });
    },
    //泊位周转率
    getBerthTurnover() {
      post("/yypark/back/wx/sys/getBerthTurnover", {
        parkId: that.parkId,
      }).then((res) => {
        if (res.state) {
          let d = res.data;
          let mon = [];
          let monData = [];
          d.forEach((item, index) => {
            mon.push(item.dateTimeStr);
            monData.push(item.stayCarNumDay);
          });
          that.option3.xAxis.data = mon;
          that.option3.series[0].data = monData;
          echarts3.setOption(that.option3);
        } else {
        }
      });
    },
    //当日进出场次数以及当前车辆停放时长

    inAndOutAndInSpotTime() {
      post("/yypark/back/wx/biz/inAndOutAndInSpotTime", {
        parkId: that.parkId,
      }).then((res) => {
        if (res.state) {
          that.inAndOutAndInSpotTimeInfo = res.data;
          that.progressnum = parseInt(res.data.inPencentage) / 100;
          that.progressnum1 = 1 - that.progressnum;
          let b = [
            {
              value: parseInt(res.data.in30M),
              name: "30分钟以内",
            },
            {
              value: parseInt(res.data.out30In60M),
              name: "30—60分钟",
            },

            {
              value: parseInt(res.data.out2In4H),
              name: "2—4小时",
            },
            {
              value: parseInt(res.data.out4H),
              name: "4小时以上",
            },

            {
              value: parseInt(res.data.out1In2H),
              name: "1—2小时",
            },
            {
              value: 80,
              name: "",
              labelLine: {
                lineStyle: {
                  color: "transparent",
                },
                length: 0,
              },
              label: {
                normal: {
                  color: "transparent",
                },
                emphasis: {
                  show: false,
                },
              },
              itemStyle: {
                normal: {
                  color: "transparent",
                },
              },
            },
          ];
          that.option4.series[0].data = b;
          echarts4.setOption(that.option4, true);
        } else {
          // this.$message({
          //   showClose: true,
          //   message: res.message,
          //   type: "error",
          // });
        }
      });
    },
    //已巡车位数

    getSpotNum() {
      post("/yypark/back/wx/biz/getSpotNum", {
        robotId: that.parkId,
      }).then((res) => {
        if (res.state) {
          that.spotNum = res.data;
        } else {
          // loading.close();
          // this.$message({
          //   showClose: true,
          //   message: res.message,
          //   type: "error",
          // });
        }
      });
    },

    //统计收入

    showParkInCome() {
      echarts2.setOption(that.option2);
      post("/yypark/back/wx/biz/showParkInCome", {
        parkId: that.parkId,
      }).then((res) => {
        if (res.state) {
          that.showParkInComeInfo = res.data;
          let date = [];
          let d1 = [];
          let a = res.data.bizShowParkDtos;
          console.log(a.length);
          a.forEach((item, index) => {
            d1.push(item.inCome / 100);
            date.push(item.time);
          });
          console.log(d1);
          console.log(date);

          that.option2.xAxis.data = date;
          that.option2.series[0].data = d1;
          echarts2.setOption(that.option2);
        } else {
          // loading.close();
          // this.$message({
          //   showClose: true,
          //   message: res.message,
          //   type: "error",
          // });
        }
      });
    },
    //违规停车数量以及异常告警数量

    getUnreasonableCarNum() {
      post("/yypark/back/wx/biz/getUnreasonableCarNum", {
        parkId: that.parkId,
      }).then((res) => {
        if (res.state) {
          that.weiguinum = res.data[0];
          that.yichangnum = res.data[1];
        } else {
        }
      });
    },
    //任务完成数

    getTasks() {
      post("/yypark/back/wx/biz/getTasks", {
        parkId: that.parkId,
      }).then((res) => {
        if (res.state) {
          that.taskNum = res.data;
        } else {
        }
      });
    },
    //查询实时气温
    getTodayWeatherTemp() {
      post("/yypark/back/wx/biz/getTodayWeatherTemp", {
        parkId: that.parkId,
      }).then((res) => {
        if (res.state) {
          that.getTodayWeatherTempInfo = res.data;
        } else {
        }
      });
    },
    //(停车场车辆概况)合集
    getAllCarNumByParkId() {
      post("/yypark/back/wx/sys/getAllCarNumByParkId", {
        parkId: that.parkId,
      }).then((res) => {
        if (res.state) {
          that.getAllCarNumByParkIdInfo = res.data;
        } else {
        }
      });
    },
    //(停车场概况)合集
    getAllNumByParkId() {
      post("/yypark/back/wx/biz/getAllNumByParkId", {
        parkId: that.parkId,
      }).then((res) => {
        if (res.state) {
          that.getAllNumByParkIdInfo = res.data;
        } else {
        }
      });
    },
    //(临停在停车数量
    getTotalShortSpotNumByParkId() {
      post("/yypark/back/wx/biz/getTotalShortSpotNumByParkId", {
        parkId: that.parkId,
      }).then((res) => {
        if (res.state) {
          that.getTotalShortSpotNumByParkIdInfo = res.data;
        } else {
        }
      });
    },
    //(临停在停车数量
    getNowTotalShortNumByParkId() {
      post("/yypark/back/wx/sys/getNowTotalShortNumByParkId", {
        parkId: that.parkId,
      }).then((res) => {
        if (res.state) {
          that.getNowTotalShortNumByParkIdInfo = res.data;
        } else {
        }
      });
    },
    //本月临停车数量
    getNowMonthTotalShortNumByParkId() {
      post("/yypark/back/wx/sys/getNowMonthTotalShortNumByParkId", {
        parkId: that.parkId,
      }).then((res) => {
        if (res.state) {
          that.getNowMonthTotalShortNumByParkIdInfo = res.data;
        } else {
        }
      });
    },
    getTime() {
      var date = new Date();
      var year = date.getFullYear();
      var mon = date.getMonth() + 1;
      var da = date.getDate(); //获取当前日

      var day = date.getDay();
      var h = date.getHours();
      var m = date.getMinutes();
      var s = date.getSeconds();
      var submitTime = "";
      submitTime += year + "-";
      if (mon >= 10) {
        // submitTime += mon + "-";
      } else {
        mon = "0" + mon;
      }
      if (da >= 10) {
        // submitTime += day;
      } else {
        da = "0" + da;
      }
      submitTime += " ";
      if (h >= 10) {
        // submitTime += h + ":";
      } else {
        h = "0" + h;
      }
      if (m >= 10) {
        // submitTime += m;
      } else {
        m = "0" + m;
      }
      if (s < 10) {
        s = "0" + s;
      }
      var weeks = new Array(
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      );
      this.y1 = year + "年" + mon + "月" + da + "日";
      this.y2 = weeks[day] + " " + h + ":" + m + ":" + s;
    },
    drawLine() {
      // 绘制图表
      echarts1.setOption(that.option1);
      // echarts2.setOption(that.option2);
      // echarts3.setOption(that.option3);
      // echarts4.setOption(that.option4);
      setTimeout(() => {
        interval1 = setInterval(function () {
          that.draw();
        }, 100);
      }, 1000);
    },
    //获取圆上面某点的坐标(x0,y0表示坐标，r半径，angle角度)
    getCirlPoint(x0, y0, r, angle) {
      let x1 = x0 + r * Math.cos((angle * Math.PI) / 180);
      let y1 = y0 + r * Math.sin((angle * Math.PI) / 180);
      return {
        x: x1,
        y: y1,
      };
    },

    draw() {
      angle = angle + 3;
      echarts1.setOption(that.option1, true);
      // window.requestAnimationFrame(draw);
    },
  },
};
</script>

<style lang="scss"  scoped>
.top {
  .f11 {
    position: absolute;
    right: 15%;
    z-index: 1000;
    top: 50px;
    height: 40px;
    width: 40px;
    display: none;
  }
}
.top:hover {
  .f11 {
    display: block;
  }
}
.center_col5txt4 {
  font-size: 23px;
  font-family: SourceHanSansSC-Bold;
  font-weight: bold;
  color: #00fff6;
  margin-top: 10px;
  margin-left: 32px;
}
.charts2 {
  position: absolute;
  bottom: 0;
  left: 20px;
  width: 100%;
  height: 200px;
}
.right_col1txt4 {
  font-size: 26px;
  font-family: SourceHanSansSC-Bold;
  font-weight: bold;
  color: #00fff6;
  margin-top: 36px;
  width: 100%;
  text-align: center;
}

.right_col1txt {
  margin-left: 90px;
  display: flex;
  justify-content: space-between;
  width: 70%;
}
.right_col1txt2 {
  margin-top: 33px;
  font-size: 30px;
  font-family: DIN-Bold;
  font-weight: bold;
  color: #fff715;
  text-align: center;
}
.right_col1txt3 {
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: 400;
  color: #ffffff;
}
.center_col5txt1 {
  margin-left: 42px;
  margin-top: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 86%;
}
.right_col1 {
  width: 100%;
  position: relative;
  height: 354px;
}
.center_col5txt2 {
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: bold;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.center_col5txt3 {
  font-size: 30px;
  font-family: DIN-Bold;
  font-weight: bold;
  color: #93ffff;
  margin-left: 19px;
}
.center_col5txt {
  font-size: 23px;
  font-family: SourceHanSansSC-Bold;
  font-weight: bold;
  color: #00fff6;
  margin-left: 32px;
  padding-top: 23px;
}
.center_col5 {
  width: 100%;
  position: relative;
  margin-top: 16px;
  height: 319px;
  margin-left: -11px;
}
.center_col4border1 {
  width: 345px;
}
.center_col4txt1 {
  margin-left: 25px;
}
.center_col4txt2 {
  margin-top: 15px;
  display: flex;
  align-items: center;
}
.center_col4txt3 {
  font-size: 18px;
  font-family: SourceHanSansSC-Regular;
  font-weight: 400;
  color: #90a9c8;
}
.center_col4txt4 {
  font-size: 18px;
  font-family: SourceHanSansSC-Bold;
  font-weight: bold;
  color: #ffffff;
  margin-left: 51px;
}
.center_col4border {
  margin-top: 14px;
  // text-align: right;
  display: flex;
}
.gelixian {
  width: 433px;
  height: 10px;
  margin-right: 2%;
}
.center_col3 {
  margin-top: 13px;
  display: flex;
}
.center_col4 {
  margin-top: 3px;
  display: flex;
}
.center_title3 {
  width: 45px;
  height: 22px;
  line-height: 22px;
  font-size: 30px;
  font-family: DIN-Bold;
  font-weight: bold;
  color: #93ffff;
  margin-bottom: 3px;
}
.center_col3txt1 {
  width: 324px;
  height: 224px;
  // padding: 7px;
}
.center_col3table {
  width: 400px;
  height: 200px;
  margin-left: 21px;
  margin-top: 14px;
  ::v-deep .header-item {
    font-size: 20px;
    font-family: SourceHanSansSC-Bold !important;
    font-weight: bold;
    color: #e8b372;
  }
  .row-item {
    color: #90a9c8;
    font-size: 20px;
    font-family: SourceHanSansSC-Regular;
    font-weight: bold;
  }
}
.center_title2 {
  width: 180px;
  height: 68px;
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  ::v-deep .border-box-content {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
  }
}
.border-box-content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.center_title1 {
  display: flex;
  justify-content: space-between;
  margin-top: 19px;
}
.center_title {
  width: 100%;
  text-align: center;
  height: 26px;
  line-height: 26px;
  font-size: 26px;
  font-family: SourceHanSansSC-Bold;
  font-weight: bold;
  color: #00fff6;
}
.topImage {
  width: 1920px;
  height: 94px;
  z-index: 222;
}
.top {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 94px;
  position: relative;
}
.topTxt1 {
  // width: 268px;
  height: 28px;
  font-size: 30px;
  font-family: SourceHanSansSC-Regular;
  // font-weight: 400;
  color: #fefeff;
  position: absolute;
  top: 53px;
  left: 6%;
  // line-height: 26px;
}
.topTxt2 {
  // width: 268px;
  height: 28px;
  font-size: 30px;
  font-family: SourceHanSansSC-Regular;
  font-weight: 400;
  color: #fefeff;
  position: absolute;
  top: 53px;
  right: 3%;
  // line-height: 26px;
}
.content {
  display: flex;
}
.left {
  width: 27%;
  margin: 34px 29px 0 25px;
}
.right {
  width: 27%;
  margin: 34px 0 0 0;
}
.center {
  // background: red;
  // height: 200px;
  width: 41.5%;
  margin: 28px 20px 0 0;
}
.left1 {
  width: 100%;
  height: 306px;
  position: relative;
}
.left1bgn {
  background: linear-gradient(0deg, #087bc5, #0794ee, #0794ee, #5596fe);
  opacity: 0.13;
  position: absolute;
  width: 100%;
  height: 100%;
}
.left1_txt {
  height: 25px;
  font-size: 26px;
  font-family: SourceHanSansSC-Bold;
  font-weight: bold;
  color: #00fff6;
  display: flex;
  align-items: center;
  padding-left: 16px;
  padding-top: 11px;
}
.left1_img1 {
  width: 24px;
  height: 15px;
  margin-right: 8px;
}
.left2 {
  width: 100%;
  height: 249px;
  position: relative;
  margin-top: 16px;
}
.right_col2 {
  width: 100%;
  height: 229px;
  position: relative;
  margin-top: 19px;
}
.right_col3 {
  width: 100%;
  height: 320px;
  position: relative;
  margin-top: 15px;
}
.left3 {
  width: 100%;
  height: 335px;
  position: relative;
  margin-top: 22px;
}
.left3_txt2 {
  position: absolute;
  right: 77px;
  top: 90px;
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: 400;
  color: #90a9c8;
}
.left3_txt3 {
  width: 15px;
  height: 15px;
  background: #00fff6;
  display: inline-block;
}
.left3_txt4 {
  font-size: 30px;
  font-family: DIN-Bold;
  font-weight: bold;
  color: #00fff6;
  margin-top: 3px;
  margin-left: 15px;
  display: block;
}
.left3_txt5 {
  position: absolute;
  right: 77px;
  top: 197px;
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: 400;
  color: #90a9c8;
}
.left3_txt6 {
  width: 15px;
  height: 15px;
  background: #fff715;
  display: inline-block;
}
.left3_txt7 {
  font-size: 30px;
  font-family: DIN-Bold;
  font-weight: bold;
  color: #fff715;
  margin-top: 3px;
  margin-left: 15px;
  display: block;
}
.left1_icon1 {
  width: 3px;
  height: 17px;
  background: #31cdfc;
  position: absolute;
  top: 0;
  left: 0;
}
.left1_icon2 {
  width: 3px;
  height: 17px;
  background: #31cdfc;
  position: absolute;
  top: 0;
  right: 0;
}
.left1_con2 {
  background-image: url("http://bz.njrentong.com/biaoti-bg.png");
  background-position: center center;
  background-repeat: no-repeat;
  // background-attachment: fixed;
  background-size: cover;
  margin-top: 12px;
  margin-left: 2%;
  width: 96%;
  height: 55px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.left_contxt1 {
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: bold;
  color: #ffffff;
  margin-left: 29px;
}
.left_contxt2 {
  font-size: 30px;
  font-family: DIN-Bold;
  font-weight: bold;
  color: #fff715;
  margin-right: 31px;
}
.right_contxt2 {
  font-size: 20px;
  font-family: Adobe Heiti Std R;
  font-weight: bold;
  color: #fff715;
  margin-right: 31px;
}
.left1_con3 {
  margin-top: 23px;
  margin-left: 18px;
}
.left1_con3txt1 {
  display: flex;
  justify-content: space-between;
}
.left1_con3txt6 {
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
}
.left1_con3txt10 {
  display: flex;
  justify-content: space-between;
  margin-top: 34px;
}
.left1_con3txt2 {
  display: flex;
  width: 280px;
}
.left1_con3txt3 {
  display: flex;
  // align-items: center;
  flex-direction: column;
}
.left1_con3txt4 {
  width: 98px;
  height: 25px;
  background: #00fff6;
  border-radius: 6px;
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: 400;
  color: #1e196d;
  text-align: center;
  line-height: 25px;
}
.left1_con3txt5 {
  font-size: 30px;
  font-family: DIN-Bold;
  font-weight: bold;
  color: #ffffff;
  height: 22px;
  line-height: 22px;
  margin-top: 15px;
  text-align: left;
}
.left1_con3img1 {
  width: 82px;
  height: 58px;
  margin-right: 21px;
}
.left_con4 {
  position: relative;
  width: 63px;
  height: 52px;
}
.left2_con3border {
  width: 4px;
  height: 52px;
  background: #0beec2;
  position: absolute;
  left: 0;
}
.left2_con3overmask {
  width: 52px;
  height: 52px;
  background: linear-gradient(87deg, #0beec2 0%, rgba(11, 238, 194, 0.11) 100%);
  opacity: 0.2;
  position: absolute;
  right: 0;
}
.left1_con3img2 {
  position: absolute;
  top: 14px;
  right: 10px;
  width: 31px;
  height: 25px;
}
.weiting {
  position: absolute;
  bottom: 13px;
  left: 22px;
  width: 36px;
  height: 25px;
}
.left1_con3img4 {
  position: absolute;
  top: 14px;
  right: 10px;
  width: 36px;
  height: 25px;
}
.yxun {
  position: absolute;
  bottom: 13px;
  left: 23px;
  width: 25px;
  height: 26px;
}
.left1_con3img5 {
  position: absolute;
  top: 14px;
  right: 10px;
  width: 23px;
  height: 32px;
}
.yichang {
  position: absolute;
  bottom: 9px;
  left: 25px;
  width: 29px;
  height: 33px;
}
.left1_con3img3 {
  position: absolute;
  top: 14px;
  right: 10px;
  width: 26px;
  height: 26px;
}
.renwu {
  position: absolute;
  bottom: 12px;
  left: 26px;
  width: 21px;
  height: 26px;
}
.left1_con3txt7 {
  display: flex;
  flex-direction: column;
  margin-left: 29px;
}
.left1_con3txt8 {
  // width: 90px;
  height: 19px;
  line-height: 19px;
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: 400;
  color: #90a9c8;
  margin-bottom: 9px;
}
.left1_con3txt9 {
  width: 45px;
  height: 23px;
  line-height: 23px;

  font-size: 30px;
  font-family: DIN-Bold;
  font-weight: bold;
  color: #93ffff;
}
.charts {
  position: absolute;
  top: -14px;
  left: -52px;
  width: 400px;
  height: 400px;
}
.progress {
  width: 200px;
  margin-left: 46px;
  margin-top: 10px;
}
</style>
